import XDomainCookieManager from '../XDomainCookieManager';
import { decode, encode } from '../hashing';
import uuid from '../uuid4';

// in-memory new user identifier
// ensures multiple async calls return the same value when cookie does not exist initially
const legacyIdSeed = parseInt(Math.random() * 10000000000, 10);
const id = uuid();

const unhash = val => {
  if (val.indexOf('.') !== 0) {
    // This may be a V1, unhashed id
    // TODO: instrument this
    const m = /[0-9A-Za-z]+/.exec(val);
    if (m !== null && m[0] === val) {
      return parseInt(val, 36);
    } else {
      // this is not a valid id
      return false;
    }
  }

  const salt = val.substr(1, 2);
  const strId = val.substr(3);

  return decode(strId, { salt });
};

const hash = val => {
  const salt = parseInt(Math.random() * 25 + 10, 10).toString(36) +
    parseInt(Math.random() * 25 + 10, 10).toString(36);
  return `.${salt}${encode(val, { salt, length: 0 })}`;
};

const parseFromCookieValue = cookieValue => {
  const { u: legacyIdentifier, uuid: identifier } = decodeURIComponent(cookieValue)
    .split('&')
    .map(part => part.split('='))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

  return {
    legacyIdentifier: unhash(legacyIdentifier || ''),
    identifier,
  };
};

export const getUserId = ({ env, legacy = true }) => {
  const cookieManager = new XDomainCookieManager({
    namespace: 'bf-xdomain-tracking',
    cookieName: 'bf_visit',
    daysExpiry: 10000,
    env,
  });

  return cookieManager.get()
    .then(value => {
      const { legacyIdentifier, identifier } = parseFromCookieValue(value);
      const hashedId = hash(legacyIdSeed);
      if (legacy) {
        if (!legacyIdentifier) {
          cookieManager.set(encodeURIComponent(`u=${hashedId}&uuid=${identifier || id}&v=2`));
          return legacyIdSeed;
        }

        return legacyIdentifier;
      }

      // If a new identifier exists it means it was created by the code below, so we'll return it
      // If the new identifier does not exist, we'll try to return the legacy identifier.
      if (identifier || legacyIdentifier) {
        return identifier || String(legacyIdentifier);
      }

      // This means we don't have any identifier available, so we'll create both, but use the new one.
      cookieManager.set(encodeURIComponent(`u=${hashedId}&uuid=${id}&v=2`));
      return id;
    });
};

export default {
  getUserId
};
